export { MainModel } from './Main.model';
export { BuyModel } from './Buy.model';
export { DetailModel } from './Detail.model';
